module.exports = "/assets/data/8f478c28805e06d533462a234ce23f4f-SW5.data.json";